import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  FormControl,
  Card,
  CardContent
} from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import SettingsIcon from '@mui/icons-material/Settings'

const ConnectionTypeSelector = ({ connectionType, onChange }) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ mb: 4 }}>
      <FormControl component="fieldset" sx={{ width: '100%' }}>
        <RadioGroup
          value={connectionType}
          onChange={onChange}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 3,
            justifyContent: 'space-between'
          }}
        >
          <Card
            variant="outlined"
            sx={{
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 3,
              flex: 1,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.02)'
              }
            }}
            onClick={() => onChange({ target: { value: 'manual' } })}
          >
            <CardContent sx={{ py: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                <Radio
                  checked={connectionType === 'manual'}
                  onChange={onChange}
                  value="manual"
                />
                <SettingsIcon sx={{ color: 'primary.main' }}/>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.9rem' }}>
                    {t('mailTemplate.users.modal.manualConfiguration')}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'text.primary', opacity: 0.7, mt: 0.2, display: 'block' }}>
                    {t('mailTemplate.users.modal.manualDescription')}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          <Card
            variant="outlined"
            sx={{
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 3,
              flex: 1,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.02)'
              }
            }}
            onClick={() => onChange({ target: { value: 'gmail' } })}
          >
            <CardContent sx={{ py: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                <Radio
                  checked={connectionType === 'gmail'}
                  onChange={onChange}
                  value="gmail"
                />
                <EmailIcon sx={{ color: 'primary.main' }}/>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.9rem' }}>
                    {t('mailTemplate.users.modal.connectWithGmail')}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'text.primary', opacity: 0.7, mt: 0.2, display: 'block' }}>
                    {t('mailTemplate.users.modal.gmailDescription')}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </RadioGroup>
      </FormControl>
    </Box>
  )
}

export default ConnectionTypeSelector
